import firebase from "firebase";

const config = {
  apiKey: "AIzaSyAQLWxwPyEp4F9gHKWpjBtPcWx0gEJZ3ms",
  authDomain: "bc4u-f40de.firebaseapp.com",
  databaseURL: "https://bc4u-f40de-prod.firebaseio.com",
  // databaseURL: "https://bc4u-f40de.firebaseio.com",
  projectId: "bc4u-f40de",
  storageBucket: "bc4u-f40de.appspot.com",
  messagingSenderId: "373350557007"
};

firebase.initializeApp(config);
const database = firebase.database();

export const firebaseAuth = firebase.auth;
export const ref = firebase.database().ref();

export default database;
